import { LandingTextBlock } from "../LandingTextBlock/LandingTextBlock";
import { ContentRendererContainer } from "./ContentRendererContainer";
import { ContentRendererBody } from "./ContentRendererBody";
import { CommonContainerPropsComponent } from "../../../api/content-client/service";

interface Props {
  body?: any;
  containerProps?: CommonContainerPropsComponent;
  isCentered?: boolean;
  media?: any;
  title?: string;
  variant?: "h1" | "h2" | "h3" | null;
  isForAgreementGeneration?: boolean;
}

export function ContentRendererTextBlock(block: Props) {
  const { body, isCentered, media, title, variant, containerProps, isForAgreementGeneration } = block || {};

  const bodyVariantBy: Record<"h1" | "h2" | "h3", "bodyXl" | "bodyLg"> = {
    h1: "bodyXl",
    h2: "bodyLg",
    h3: "bodyLg",
  };

  return (
    <ContentRendererContainer containerProps={containerProps} isForAgreementGeneration={isForAgreementGeneration}>
      <LandingTextBlock
        image={media?.data?.attributes?.url}
        isCentered={isCentered}
        title={title}
        variant={variant || "h1"}
        isForAgreementGeneration={isForAgreementGeneration}
      >
        <ContentRendererBody
          body={body}
          paragraphVariant={bodyVariantBy[variant || "h1"]}
          paragraphSx={{ maxWidth: isForAgreementGeneration ? undefined : "956px" }}
          isForAgreementGeneration={isForAgreementGeneration}
        />
      </LandingTextBlock>
    </ContentRendererContainer>
  );
}
